import { render, staticRenderFns } from "./FormCourseEdit.vue?vue&type=template&id=4a3ca396&"
import script from "./FormCourseEdit.vue?vue&type=script&lang=js&"
export * from "./FormCourseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports